<div class="list-your-machines-layout container-default bg-white pb-0">
  <app-list-your-machines-header></app-list-your-machines-header>
  <!-- <app-list-your-machines-profit></app-list-your-machines-profit> -->
  <app-list-your-machines-peace></app-list-your-machines-peace>
  <app-list-your-machines-we-handle></app-list-your-machines-we-handle>
  <app-list-your-machines-manage></app-list-your-machines-manage>
  <app-list-your-machines-get-paid></app-list-your-machines-get-paid>
  <app-list-your-machines-support></app-list-your-machines-support>
</div>
<common-footer></common-footer>
